import React from 'react';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white px-5 py-8 border-y border-slate-100" data-id="element-156">
      <div className="max-w-2xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10 text-center" data-id="element-157">
        <div className="flex items-center gap-2" data-id="element-158">
          <div className="flex" data-id="element-159">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-brand-cream-300 text-brand-cream-300" data-id="element-160" />)}
          </div>
          <span className="text-sm font-semibold text-slate-700" data-id="element-161">4.9/5</span>
          <span className="text-sm text-slate-500" data-id="element-162">(+800 reseñas)</span>
        </div>
        <div className="h-4 w-px bg-slate-200 hidden sm:block" data-id="element-163" />
        <p className="text-sm text-slate-600" data-id="element-164">
          <span className="font-semibold text-brand-ink" data-id="element-165">
            Miles de familias
          </span>{' '}
          ya usan Crecer Jugando
        </p>
      </div>
    </section>;
}